import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Paper } from '@mui/material'
import moment from 'moment'
import PropTypes from 'prop-types'

import CarDataTable from '../CarDataTable'

function DigitalCertificateCarBasicData({ certificateData }) {
  const { basicData } = certificateData
  const { t } = useTranslation()
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={6}>
        <Paper elevation={0}>
          <CarDataTable
            data={[
              { label: 'VIN', value: basicData.vin },
              {
                label: t('regNo'),
                value: basicData.registrationNumber,
              },
              {
                label: t('mileage'),
                value: basicData.mileage,
              },
            ]}
          />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={0}>
          <CarDataTable
            data={[
              {
                label: t('color'),
                value: basicData.color,
              },
              {
                label: t('productionYear'),
                value: basicData.manufacturingYear,
              },
              {
                label: t('firstRegistrationDate'),
                value: moment(basicData.firstRegistrationDate).format(
                  'DD-MM-YYYY',
                ),
              },
            ]}
          />
        </Paper>
      </Grid>
    </Grid>
  )
}

DigitalCertificateCarBasicData.propTypes = {
  certificateData: PropTypes.object,
}

DigitalCertificateCarBasicData.defaultProps = {
  certificateData: null,
}

export default DigitalCertificateCarBasicData
